export enum ProjectEmployeeType {
  "PI on Project" = 0,
  "Paid on Project" = 1
}
